// Getters
export const TASKS = 'plan_implementation/TASKS'
export const MILESTONES = 'plan_implementation/MILESTONES'
export const SECONDARY_GOALS = 'plan_implementation/SECONDARY_GOALS'

// Mutations
export const MUTATE_TASKS = 'plan_implementation/MUTATE_TASKS'
export const MUTATE_MILESTONES = 'plan_implementation/MUTATE_MILESTONES'
export const MUTATE_SECONDARY_GOALS = 'plan_implementation/MUTATE_SECONDARY_GOALS'

// Actions
export const GET_TASKS = 'plan_implementation/GET_TASKS'
export const CREATE_TASK = 'plan_implementation/CREATE_TASK'
export const UPDATE_TASK = 'plan_implementation/UPDATE_TASK'
export const DELETE_TASK = 'plan_implementation/DELETE_TASK'

export const GET_MILESTONES = 'plan_implementation/GET_MILESTONES'
export const CREATE_MILESTONE = 'plan_implementation/CREATE_MILESTONE'
export const UPDATE_MILESTONE = 'plan_implementation/UPDATE_MILESTONE'
export const DELETE_MILESTONE = 'plan_implementation/DELETE_MILESTONE'

export const GET_SECONDARY_GOALS = 'plan_implementation/GET_SECONDARY_GOALS'
export const CREATE_SECONDARY_GOAL = 'plan_implementation/CREATE_SECONDARY_GOAL'
export const UPDATE_SECONDARY_GOAL = 'plan_implementation/UPDATE_SECONDARY_GOAL'
export const DELETE_SECONDARY_GOAL = 'plan_implementation/DELETE_SECONDARY_GOAL'
